import { create } from 'zustand';
import { 
    situacaoTripsTypes,
    desempenhoTripsTypes 
} from '../utils/tripUtils';

import { 
    sendSituacoes, 
    sendDesempenho 
} from '../channels/tripsChannel';

function getSituacoesSelecionadas() {

    try {

        const saved = localStorage.getItem('situacoesSelecionadas');

        return saved
            ? JSON.parse(saved)
            : situacaoTripsTypes.map(i => i.id);

    } catch {
        return situacaoTripsTypes.map(i => i.id);
    }

}

function saveSituacoesSelecionadas(situacoesSelecionadas) {

    try {

        localStorage.setItem('situacoesSelecionadas',
            JSON.stringify(situacoesSelecionadas)
        );
        
    } catch {}

}

function getDesempenhosSelecionados() {

    try {

        const saved = localStorage.getItem('desempenhosSelecionados');

        return saved
            ? JSON.parse(saved)
            : desempenhoTripsTypes.map(i => i.id);

    } catch {
        return desempenhoTripsTypes.map(i => i.id);
    }
}

function saveDesempenhosSelecionados(desempenhosSelecionados) {

    try {

        localStorage.setItem('desempenhosSelecionados',
            JSON.stringify(desempenhosSelecionados)
        );
        
    } catch {}

}

const initialSituacoesSelecionadas = getSituacoesSelecionadas();

const initialDesempenhosSelecionados = getDesempenhosSelecionados();

export const useTripFiltersStore = create((set) => ({
    
    situacaoTripsTypes,

    desempenhoTripsTypes,

    situacoesSelecionadas: initialSituacoesSelecionadas,
    situacoesSet: new Set(initialSituacoesSelecionadas),

    desempenhosSelecionados: initialDesempenhosSelecionados,
    desempenhosSet: new Set(initialDesempenhosSelecionados),

    setSituacoesSelecionadas: (situacoesSelecionadas, broadcast = true) => {
        
        set({
            situacoesSelecionadas,
            situacoesSet: new Set(situacoesSelecionadas)
        });
        saveSituacoesSelecionadas(situacoesSelecionadas);

        if (broadcast) {
            sendSituacoes(situacoesSelecionadas);
        }

    },

    setDesempenhosSelecionados: (desempenhosSelecionados, broadcast = true) => {
        set({
            desempenhosSelecionados,
            desempenhosSet: new Set(desempenhosSelecionados)
        });
        saveDesempenhosSelecionados(desempenhosSelecionados);

        if (broadcast) {
            sendDesempenho(desempenhosSelecionados);
        }

    }

}));